import { logger } from '@getvim/vim-connect-logger';

export const createLogger = (componentName: string) =>
  logger.scope(`Optum Order Utility Client [${componentName}]`);
